import React, { useState } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';

const ICON_BY_TYPE = {
    'Círculo': 'fa-circle',
    'Retângulo': 'fa-square',
    'Polígono': 'fa-draw-polygon',
};

const isCircle = (shape) => shape.type === 'Círculo';

function RadiusPopover({ shape, onSetRadius }) {
    const [radius, setRadius] = useState(Math.round(shape.radiusMeters || 0));

    const popover = (
        <Popover id={`popover-raio-${shape.drawId}`}>
            <Popover.Title as="h3">Editar Raio do Círculo (m)</Popover.Title>
            <Popover.Content>
                <div className="d-flex align-items-center" style={{ gap: 6 }}>
                    <input
                        type="number"
                        min="1"
                        className="form-control form-control-sm"
                        value={radius}
                        onChange={(e) => setRadius(e.target.value)}
                        style={{ width: 110 }}
                    />
                    <button
                        title="Salvar"
                        className="btn btn-success btn-sm"
                        onClick={() => onSetRadius(shape, parseFloat(radius))}
                    >
                        <i className="fa-solid fa-check"></i>
                    </button>
                </div>
            </Popover.Content>
        </Popover>
    );

    return (
        <OverlayTrigger trigger="click" placement="top" rootClose overlay={popover}>
            <button className="mapbox-shape-btn" title="Alterar Raio do Círculo">
                <i className="fa-solid fa-up-right-and-down-left-from-center"></i>
            </button>
        </OverlayTrigger>
    );
}

// Item em duas linhas: nome completo (sem cortes) em cima, ações compactas embaixo.
// A edição do nome acontece pela edição de atributos da forma (fa-sliders).
function ShapeItem({ shape, onCenter, onToggleVisibility, onSetRadius, onEditAttributes, onRemove }) {
    return (
        <li className="mapbox-shape-item" style={{ borderLeft: `4px solid ${shape.color || '#ccc'}` }}>
            <div className="mapbox-shape-item-name" style={{ opacity: shape.visible ? 1 : 0.5 }}>
                <i className={`fa-solid ${ICON_BY_TYPE[shape.type] || 'fa-shapes'}`} style={{ color: shape.color }}></i>
                <span>{shape.name}</span>
                <small className="text-muted">{shape.type}</small>
            </div>

            <div className="mapbox-shape-item-actions">
                <button className="mapbox-shape-btn" title="Centralizar Mapa na Forma" onClick={() => onCenter(shape)}>
                    <i className="fa-solid fa-bullseye"></i>
                </button>

                {onEditAttributes && (
                    <button className="mapbox-shape-btn" title="Editar Atributos da Forma (nome, cores…)" onClick={() => onEditAttributes(shape)}>
                        <i className="fa-solid fa-sliders"></i>
                    </button>
                )}

                <button
                    className="mapbox-shape-btn"
                    title={shape.visible ? 'Esconder' : 'Mostrar'}
                    onClick={() => onToggleVisibility(shape)}
                >
                    <i className={`fa-solid ${shape.visible ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                </button>

                {isCircle(shape) && <RadiusPopover shape={shape} onSetRadius={onSetRadius} />}

                <button className="mapbox-shape-btn mapbox-shape-btn-danger" title="Remover" onClick={() => onRemove(shape)}>
                    <i className="far fa-trash-alt"></i>
                </button>
            </div>
        </li>
    );
}

export default function DrawnShapesList({ shapes, onCenter, onToggleVisibility, onSetRadius, onEditAttributes, onRemove }) {
    if (!shapes || shapes.length === 0) return null;

    return (
        <ul className="mapbox-shapes-list">
            {shapes.map((shape) => (
                <ShapeItem
                    key={shape.drawId}
                    shape={shape}
                    onCenter={onCenter}
                    onToggleVisibility={onToggleVisibility}
                    onSetRadius={onSetRadius}
                    onEditAttributes={onEditAttributes}
                    onRemove={onRemove}
                />
            ))}
        </ul>
    );
}
